"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "relative"
};
const _hoisted_2 = ["src"];
const store_1 = require("@/state/store");
const detectingMobile_1 = __importDefault(require("@/services/detectingMobile"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'ImageModalDesktop',
    props: {
        imgSource: {}
    },
    setup(__props) {
        const { isMobile } = (0, detectingMobile_1.default)();
        return (_ctx, _cache) => {
            return (!(0, vue_2.unref)(store_1.store).isLandingPage && !(0, vue_2.unref)(isMobile))
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                    (_ctx.imgSource)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("img", {
                            key: 0,
                            class: "h-full w-full object-cover",
                            src: _ctx.imgSource,
                            alt: "",
                            loading: "lazy"
                        }, null, 8, _hoisted_2))
                        : (0, vue_2.createCommentVNode)("", true)
                ]))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
